const formatWadoRsToWado = function (urlRS, jpeg) {
  var url = !jpeg ? 'wadouri:' : ''
  url += urlRS.split('/rs/')[0] + '/wado?requestType=WADO'
  url += '&studyUID=' + urlRS.split('/studies/')[1].split('/')[0]
  url += '&seriesUID=' + urlRS.split('/series/')[1].split('/')[0]
  url += '&objectUID=' + urlRS.split('/instances/')[1].split('/')[0]
  url += jpeg ? '' : '&contentType=application/dicom&transferSyntax=1.2.840.10008.1.2.4.90'

  return url
}

export { formatWadoRsToWado }



// WEBPACK FOOTER //
// ./src/utils/dicom.js